import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';
import { getAllRecommendations, approveRecommendation, updateRecommendation } from '../../api/recommendationAPI';
import '../Profile.css';
import { ADMIN_EMAIL } from '../../constants';

const AdminRecommendations = () => {
  const { user } = useUser();
  const navigate = useNavigate();
  const [recs, setRecs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('pending');
  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({ name: '', text: '', itemId: '', status: '' });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!user || user.email !== ADMIN_EMAIL) { navigate('/', { replace: true }); return; }
    getAllRecommendations()
      .then(data => setRecs(Array.isArray(data) ? data : []))
      .catch(() => setRecs([]))
      .finally(() => setLoading(false));
  }, [user, navigate]);

  if (!user || user.email !== ADMIN_EMAIL) return null;

  const pending = recs.filter(r => r.status === 'pending' || r.status === 'בתהליך');
  const approved = recs.filter(r => r.status === 'approved' || r.status === 'אושר');
  const displayed = tab === 'pending' ? pending : approved;

  const handleApprove = async (id) => {
    await approveRecommendation(id);
    setRecs(prev => prev.map(r => r.id === id ? { ...r, status: 'approved' } : r));
  };

  const startEdit = (rec) => {
    setEditId(rec.id);
    setEditData({ name: rec.name, text: rec.text, itemId: rec.item_id || '', status: rec.status || '' });
  };

  const handleSaveEdit = async (id) => {
    setSaving(true);
    try {
      await updateRecommendation(id, editData);
      setRecs(prev => prev.map(r => r.id === id ? { ...r, name: editData.name, text: editData.text, item_id: editData.itemId, status: editData.status } : r));
      setEditId(null);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="history-page">
      <div className="admin-rec-tabs">
        <button
          className={`admin-rec-tab ${tab === 'pending' ? 'active' : ''}`}
          onClick={() => setTab('pending')}
        >
          ממתינות לאישור ({pending.length})
        </button>
        <button
          className={`admin-rec-tab ${tab === 'approved' ? 'active' : ''}`}
          onClick={() => setTab('approved')}
        >
          אושרו ({approved.length})
        </button>
      </div>

      {loading && <div className="history-status">טוען...</div>}
      {!loading && displayed.length === 0 && (
        <div className="history-status">אין המלצות להצגה.</div>
      )}

      <div className="admin-rec-list">
        {displayed.map(rec => (
          <div key={rec.id} className="admin-rec-card">
            {editId === rec.id ? (
              <div className="admin-rec-edit">
                <input
                  className="rec-popup-input"
                  value={editData.name}
                  onChange={e => setEditData(d => ({ ...d, name: e.target.value }))}
                  dir="rtl"
                  placeholder="שם"
                />
                <textarea
                  className="rec-popup-textarea"
                  value={editData.text}
                  onChange={e => setEditData(d => ({ ...d, text: e.target.value }))}
                  rows={3}
                  dir="rtl"
                  placeholder="תוכן"
                />
                <input
                  className="rec-popup-input"
                  value={editData.itemId}
                  onChange={e => setEditData(d => ({ ...d, itemId: e.target.value }))}
                  dir="rtl"
                  placeholder="Item ID"
                  type="number"
                />
                <select
                  className="rec-popup-input"
                  value={editData.status}
                  onChange={e => setEditData(d => ({ ...d, status: e.target.value }))}
                  dir="rtl"
                >
                  <option value="pending">ממתין לאישור</option>
                  <option value="approved">אושר</option>
                </select>
                <div className="admin-rec-actions">
                  <button className="rec-popup-submit" onClick={() => handleSaveEdit(rec.id)} disabled={saving}>
                    {saving ? 'שומר...' : 'שמור'}
                  </button>
                  <button className="admin-rec-cancel" onClick={() => setEditId(null)}>ביטול</button>
                </div>
              </div>
            ) : (
              <>
                <div className="admin-rec-meta">
                  <span className="admin-rec-name">{rec.name}</span>
                  <span className="admin-rec-product">{rec.product_name || `פריט #${rec.item_id}`}</span>
                </div>
                <p className="admin-rec-text">{rec.text}</p>
                <div className="admin-rec-actions">
                  {tab === 'pending' && (
                    <button className="rec-popup-submit" onClick={() => handleApprove(rec.id)}>אשר</button>
                  )}
                  <button className="admin-rec-edit-btn" onClick={() => startEdit(rec)}>עריכה</button>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminRecommendations;
